import { FunctionComponent, h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { focusToAriaElement } from '../../helpers/aria-helper';

interface Props {
	activeIndex: number;
}

const getStyle = (element, activeIndex) => {
	const activeChild = element.children[activeIndex];
	const width = `${activeChild.offsetWidth}px`;
	const height = `${activeChild.offsetHeight}px`;
	const offset = `${-1 * activeChild.offsetLeft}px`;

	return {
		'--offset': offset,
		'--width': width,
		'--height': height
	};
};

const SlidingContentBox: FunctionComponent<Props> = ({ activeIndex, children }) => {
	const [style, setStyle] = useState(null);
	const contentRef = useRef(null);

	useEffect(() => {
		setStyle(getStyle(contentRef.current, activeIndex));

		focusToAriaElement(contentRef);
	}, [activeIndex, contentRef.current, children]);

	return (
		<div className="sliding-content-box" style={style} data-testid="sliding-content-box">
			<div className="content" ref={contentRef}>
				{children}
			</div>
		</div>
	);
};

export default SlidingContentBox;
